const canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

const isNodeGlobalDefined = typeof global !== 'undefined';

const ExecutionEnvironment = {
  isServer: !canUseDOM && isNodeGlobalDefined,
};

export default ExecutionEnvironment;
